import { BookSingleController } from '../controllers/book-single';
import { LocalStorageService } from '@DavisDigital/davisdigitalfrontend.module';

class BookPreviewController extends BookSingleController {
	public bookId;
	public previewFlag:boolean = true;
	public viewAs:string = 'single';
	// @ngInject
	constructor( 
		public $q,
		public $attrs, 
		public $scope,
		public $timeout,
		public bookService,
		public apiService,
		public observerService,
		public $location,
		public $sce,
		public ModalService,
		public localStorageService,
		public davisAlertService
	) {
        super($q,$attrs,$scope,$timeout,bookService,apiService,observerService,$location,$sce,ModalService,localStorageService, davisAlertService);
	}
    
	// For use as controller for modal directive
	public close = () =>{

		var modalToCloseIndex = 0;
		if(this.ModalService.openModals.length === 2){
			modalToCloseIndex = 1;
		}
		//This is a workaround ModalService technically does not support more than one modal
		var thisModal = this.ModalService.openModals[modalToCloseIndex];
		thisModal.modal.element.modal('hide');
		this.ModalService.openModals.splice(modalToCloseIndex, 1);
		thisModal.modal.element.remove();
	}
	
	public goToPage = ( pageNumber: number ) => {

		this.pageNumber = pageNumber;
		this.$location.search("pageNumber", this.pageNumber);
		this.renderMediaViewer();
	}
}

class BookPreview {
	public restrict: string = 'E';
	public scope: boolean = true;
	
	public bindToController: any = {
		bookId:'=?',
		pageNumber:'=',
		previewFlag:'='
	};

	public controller = BookPreviewController;
	public controllerAs = 'bookPreview';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/book-preview.html';

	public static Factory() {
		return () => new this();
	}
}

export { BookPreview };
